import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import { StaticStoreItem } from "../domain/models/static-store-item.model";

@Injectable()
export class StaticStoreService {

    constructor(private http: HttpClient) {
    }

    public Get(source: string): Observable<StaticStoreItem[]> {
        return this.http.get<StaticStoreItem[]>(`staticStore/${source}.${environment.country}.json`);
    }
}
